export function jsonToBase64(jsonStr) {
  const encodedUriComp = encodeURIComponent(jsonStr);
  return btoa(encodedUriComp);
}
export function base64ToJson(base64Str) {
  const decodedUriComp = atob(base64Str);
  return decodeURIComponent(decodedUriComp);
}

export function setItemWithExpiry(key, value, ttl) {
  const now = new Date();

  // `ttl` 参数是以毫秒为单位的生存时间
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };

  localStorage.setItem(key, jsonToBase64(JSON.stringify(item)));
}

export function getItemWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(base64ToJson(itemStr));
  const now = new Date();

  // 比较当前时间和项的过期时间
  if (now.getTime() > item.expiry) {
    // 如果过期了，则删除该项并返回null
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}
